export default "__VITE_ASSET__bb6db704__"